import {styled} from "@mui/material";

const AppLink = styled('span')`
  cursor: pointer;
  color: #06326E;
`;

export default AppLink;
